import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/@dva/shared/material-components.module';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MaterialModule, TranslateModule, FormsModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
